


























import { BFormInput, VBTooltip } from 'bootstrap-vue';
import { mapGetters } from 'vuex';
import InsertVariableButton from './InsertVariableButton.vue';

export default {
  name: 'InputWithVariables',
  components: {
    BFormInput,
    InsertVariableButton,
  },
  directives: {
    BTooltip: VBTooltip,
  },
  inheritAttrs: false,
  props: {
    value: {
      type: String,
      required: true,
    },
    inputVariables: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      lastTextSelection: {
        index: 0,
        length: 0,
      },
    };
  },
  computed: {
    ...mapGetters(['featureFlags']),
  },
  watch: {
    value() {
      this.restoreTextSelection();
    },
  },
  methods: {
    insertVariable(variable: string) {
      let content = this.value;
      let pos = this.lastTextSelection.index;
      let posEnd = this.lastTextSelection.index + this.lastTextSelection.length;
      const newContent = `${content.slice(0, pos)}${variable}${content.slice(posEnd)}`;
      this.$emit('input', newContent);
      this.lastTextSelection.index = pos;
      this.lastTextSelection.length = variable.length;
    },
    async restoreTextSelection() {
      await this.$nextTick();
      let pos = this.lastTextSelection.index;
      let posEnd = pos + this.lastTextSelection.length;
      this.$refs.textInput.focus();
      this.$refs.textInput.setSelectionRange(pos, posEnd);
      this.saveLastTextSelection(false, this.$refs.textInput);
    },
    saveLastTextSelection(event, input) {
      input = (event && event.target) || input;
      this.lastTextSelection = {
        index: input.selectionStart || 0,
        length: input.selectionEnd - input.selectionStart || 0,
      };
    },
  },
};
